module.exports = __webpack_public_path__ + "static/media/6.7038b55e.png";